<template>
  <div>
    <div class="section-heading">
      <div class="container">
        <h1 class="section-heading__title">Panel de información</h1>
      </div>
    </div>

    <we-tabs v-if="!loading" ref="tabs" class="dashboard">
      <we-tab name="Mercado" :selected="true">
        <MarketDashboard :dashboardTab="'market'" :isMix="isMix" />
      </we-tab>
      <we-tab v-if="!hideRanking" name="Ranking">
        <OrganizationRanking/>
      </we-tab>
      <we-tab name="Entidad">
        <EntityDashboard :dashboardTab="'entity'" :isMix="isMix" />
      </we-tab>
    </we-tabs>
  </div>
</template>

<script>
import WeTabs from "@/lib/WebExperto/components/WeTabs.vue";
import WeTab from "@/lib/WebExperto/components/WeTab.vue";
import EntityDashboard from "@/components/dashboard/EntityDashboard";
import MarketDashboard from "@/components/dashboard/MarketDashboard";
import OrganizationRanking from "@/components/dashboard/OrganizationRanking.vue";
import { mapState, mapMutations } from "vuex";
import gql from 'graphql-tag'
import axios from "axios";
import { print } from 'graphql'

axios.defaults.headers.common["referer-id"] =
  new Date().toLocaleString().replace(/[^\d]/g, "") +
  parseInt(Math.random() * 100000);

const isHideRanking = gql`
  query {
    isHideRanking
  }
`

export default {
  name: "Dashboard",
  components: {
    EntityDashboard,
    MarketDashboard,
    OrganizationRanking,
    "we-tabs": WeTabs,
    "we-tab": WeTab,
  },

  data () {
    return {
      loading: true,
      hideRanking: undefined,
    }
  },

  created() {
    this.isRankingHidden();
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.User.currentUser,
    }),
    isMix() {
      if (this.currentUser.canSell && this.currentUser.canBuy) {
        return true;
      }
      return false;
    },
  },

  methods: {
    isRankingHidden() {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(isHideRanking)
      }}).then(res => {
        this.hideRanking = res.data.data.isHideRanking;
        this.loading = false;
      }).catch((err) => {
        console.log(err)
      })
    },
  },
};
</script>
